<template>
    <div class="head-content">
        <div class="l-content">
            <el-button @click="handleMuen" icon="el-icon-menu" size="mini"></el-button>
            <!-- 面包屑 -->
            <el-breadcrumb  separator-class="el-icon-arrow-right" class="breadcrumb-container">
                <router-link v-for="item in $store.state.teb.tabsList" :key="item.path" :to="item.path" :replace="true">
                        <el-breadcrumb-item style="margin:5px">{{ item.name }}</el-breadcrumb-item>
                        <h1></h1>
                </router-link>
            </el-breadcrumb>
        </div>
        <div class="r_content">
            <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link"  >
                    <img  v-if="$store.state.teb.avatar" class="user" :src="$store.state.teb.avatar">
                    <img  v-else-if="avatar" class="user" :src="avatar">
                    <img  v-else class="user" src="../images/user.png">
                </span>
           
                <el-dropdown-menu slot="dropdown" >
                    <el-dropdown-item command="center" >Personal center</el-dropdown-item>
                    <el-dropdown-item command="quit">quit</el-dropdown-item>
                </el-dropdown-menu>
           
            </el-dropdown>
        </div>
    </div>
</template>
<script>
export default {
    setup() {

    },
    data(){
        return{
            avatar : JSON.parse(localStorage.getItem("userData")).avatar,

        }
    },
    methods: {
        handleCommand(command) {
            if (command === 'center') {
                if(this.$route.path !=='/center'){
                    this.$router.push('/center');
                }
               // 处理个人中心命令 
            } else if (command === 'quit') {
                // 处理退出命令
                localStorage.removeItem("userData");
                this.$router.push('/login');
            }
        } ,

        handleMuen() {
            this.$store.commit('collapseMenu')
        },

        switchToMachine(row) {
            this.$store.state.teb.machineID = row.machine
            if (row.model === 'cl4') {
                this.$store.commit('getClsPosition', row.machine)
                this.$router.push('/cl4')
            } else if (row.model === 'white808') {
                this.$store.commit('getWhite808Position', row.machine)
                this.$router.push('/white808')
            } else if (row.model === 'black808') {
                this.$store.commit('getBlack808Position', row.machine)
                this.$router.push('/black808')
            }
        }
    },
    computed: {
        
    }
}
</script>

<style lang="less" scoped>
.head-content {
    padding: 0 20px;
    background-color: #333;
    height: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .text {
        color: #fff;
        font-size: 14px;
        padding: 0 14px;
    }

    .r_content {
        .user {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            margin-top: 10px;
        }
    }

    .l-content {
        display: flex;
        align-items: center;
    }

    /* 不被选中时的颜色 */
    .el-breadcrumb ::v-deep .el-breadcrumb__inner {
        color: #d9bb95 !important;
        font-weight: 400 !important;
    }

    /* 被选中时的颜色 */
    .el-breadcrumb__item:last-child ::v-deep .el-breadcrumb__inner {
        color: #fc9105 !important;
        font-weight: 800 !important;
    }
    .breadcrumb-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    




}
</style>